import axios from 'axios'

const apiClient = axios.create({
  baseURL: 'https://back.ayendaman.org',
  timeout: 30000
})

apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    let message = ''
    
    if (error.response) {
      const data = error.response.data

      if (data && data.message) {
        message = data.message
      } else if (data && data.error) {
        message = data.error
      } else if (typeof data === 'string' && data.length < 200) {
        message = data
      } else {
        message = error.message
      }
    } else if (error.request) {
      message = 'مشکل در برقراری ارتباط با سرور (Network Error)'
    } else {
      message = error.message
    }

    window.dispatchEvent(new CustomEvent('app-notify', { 
        detail: { message: message, type: 'error', duration: 15000 } 
    }))

    return Promise.reject(error)
  }
)

export const createFormData = (data = {}) => {
  const formData = new FormData()
  formData.append('apikey', process.env.VUE_APP_API_KEY)
  formData.append('debug', 'true')
  formData.append('lang', localStorage.getItem('app_lang') || 'fa')

  for (const key in data) {
    if (data[key] !== null && data[key] !== undefined) {
      formData.append(key, data[key])
    }
  }
  return formData
}

export default apiClient